import React from "react";

const Group = ({ width, height }: any) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 47 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.5" width="47" height="47" rx="23.5" fill="#D0D7DD" />
      <path
        d="M14.1687 16.3441C14.1687 19.5661 16.9364 22.1881 20.3375 22.1881C23.7385 22.1881 26.5062 19.5661 26.5062 16.3441C26.5062 13.122 23.7385 10.5 20.3375 10.5C16.9364 10.5 14.1687 13.122 14.1687 16.3441ZM31.3041 35.1749H32.6749V33.8762C32.6749 28.8646 28.3691 24.7855 23.0791 24.7855H17.5958C12.3044 24.7855 8 28.8646 8 33.8762V35.1749H31.3041Z"
        fill="white"
      />
      <path
        d="M21.9734 16.869C21.9734 20.091 24.7411 22.713 28.1421 22.713C31.5432 22.713 34.3109 20.091 34.3109 16.869C34.3109 13.6469 31.5432 11.0249 28.1421 11.0249C24.7411 11.0249 21.9734 13.6469 21.9734 16.869ZM39.1088 35.6998H40.4796V34.4011C40.4796 29.3895 36.2733 24.5 30.9833 24.5H25.5C20.2086 24.5 15.8047 29.3895 15.8047 34.4011V35.6998H39.1088Z"
        fill="white"
        stroke="#D0D7DD"
      />
    </svg>
  );
};

export default Group;
